import { useCallback, useContext, useEffect } from 'react';
import { Grid, IconButton, Tooltip, Typography } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from "@mui/material/styles";
import { useLocation, useNavigate } from 'react-router-dom';
import { ACTIONS, WizardContext } from '../wizard/Context';
import { getLocalDateTime } from '../../services/Utils';
import BorderColorIcon from '@mui/icons-material/BorderColor';

const ChatAppBar = ({
  isFullScreen,
  position,
  setOffset,
  isDragging,
  setIsDragging,
  handleNewChat,
}) => {

  const theme = useTheme();
  const { state, dispatch } = useContext(WizardContext);
  const { chatConfig } = state;
  const navigate = useNavigate();
  const location = useLocation();

  const handlePaneClose = () => {
    if (isFullScreen) {
      dispatch({
        type: ACTIONS.UPDATE_CHAT_WINDOW,
        payload: {
          chatWindowOpen: false,
        },
      })
      const from = location.state?.from || '/';
      navigate(from, { replace: true });
    } else {
      dispatch({
        type: ACTIONS.UPDATE_CHAT_WINDOW,
        payload: {
          chatWindowOpen: false,
        },
      })
    }
  }

  const handleFullScreen = () => {
    if (isFullScreen) {
      const from = location.state?.from || '/';
      navigate(from, { replace: true });
      dispatch({
        type: ACTIONS.UPDATE_CHAT_WINDOW,
        payload: {
          chatWindowOpen: true,
        },
      });
    } else {
      navigate(`/chat`, { replace: true, state: { from: location.pathname } });
    }
  }

  const ControlPane = () => {
    return (
      <Grid sx={{
        margin: '5px',
        // display: 'flex',
        // justifyContent: 'c',
        // alignItems: 'flex-end',
      }}
        container>
        <Tooltip title="New Chat">
          <IconButton
            sx={{
              padding: '10px',
              backgroundColor: theme.palette.primary[100],
            }}
            color='inherit'
            onClick={handleNewChat}
          >
            <BorderColorIcon fontSize='small' />
          </IconButton>
        </Tooltip>

        <Tooltip title={isFullScreen ? "Minimize" : "Maximize"} >
          <IconButton
            sx={{
              padding: '10px',
            }}
            color='inherit'
            onClick={handleFullScreen}
          >
            {isFullScreen ?
              <FullscreenExitIcon fontSize='small' /> :
              <FullscreenIcon fontSize='small' />}
          </IconButton>
        </Tooltip>
        <Tooltip title="Close">
          <IconButton
            sx={{
              padding: '10px',
            }}
            color='inherit'
            onClick={handlePaneClose}
          >
            <CloseIcon fontSize='small' />
          </IconButton>
        </Tooltip>
      </Grid>
    );
  };

  const handleMouseDown = (e) => {
    if (!isFullScreen) {
      setIsDragging(true);
    }

    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  }

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, [setIsDragging]);

  useEffect(() => {
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mouseup', handleMouseUp);
    }
  }, [isDragging, handleMouseUp]);

  return (
    <Grid sx={{
      color: theme.palette.primary[500],
      // flexWrap: 'nowrap',
    }}
      container>
      <Grid
        sx={{
          width: '100%',
          userSelect: 'none',
        }}
        onMouseDown={handleMouseDown}
      >
        {chatConfig?.chatId && <Grid
          sx={{
            padding: '2px 10px',
          }}
        >
          <Typography
            sx={{
              width: isFullScreen ? '600px' : '300px',
              fontSize: '15px',
              fontWeight: '500',
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {chatConfig?.title ? chatConfig?.title : "Untitled"}
          </Typography>
          <Typography
            sx={{
              width: 'fit-content',
              fontSize: '12px',
            }}
          >
            {`Created at: ${getLocalDateTime(chatConfig?.createdAt)}`}
          </Typography>
        </Grid>}
      </Grid>
      <ControlPane />
    </Grid>
  );
}

export default ChatAppBar;